/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';

export default function Icon({ title = null }) {
  return (
    <svg role="img" aria-labelledby="upArrowIcon" width="100%" height="100%" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      {title && <title id="upArrowIcon">{title}</title>}
      <path d="M4.16602 8.33333L9.99935 2.5M9.99935 2.5L15.8327 8.33333M9.99935 2.5V17.5" stroke="#585F69" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

Icon.propTypes = {
  title: PropTypes.string,
};
